import { render } from "./XFstatistics.vue?vue&type=template&id=55cf05b8&scoped=true"
import script from "./XFstatistics.vue?vue&type=script&lang=js"
export * from "./XFstatistics.vue?vue&type=script&lang=js"

import "./XFstatistics.vue?vue&type=style&index=0&id=55cf05b8&lang=scss&scoped=true"
import "./XFstatistics.vue?vue&type=style&index=1&id=55cf05b8&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cf05b8"]])

export default __exports__